// this file added for individual by Bearer Web Developer
export const validatePhone = (value: string) => {
    if (value.length === 0) return "Mobile Number is required";
    if (!(value.length === 9)) return "Mobile Number must be 9 Digits";
    if (!value.match(/^[0-9]*$/)) return "Mobile Number must be 9 Digits";
}